import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isCountriesTax } from 'countriesTax';
import { Icon } from 'semantic-ui-react';
import Carrousel from 'components/atoms/Carrousel/Carrousel';
import { Language } from 'language/Language';
import { ProductHeroButton } from './ProductHeroButton';
import { strings } from './strings';
import ProductImage from '../image/ProductImage';
import CarrouselFull from '../carrouselFull/CarrouselFull';
import { images } from '../images';
import './_ProductHero.scss';

const ProductHero = () => {
  const {
    siteInfo: { priceProduct, countryUser },
    entitlement,
  } = useSelector((state) => state);
  const [pos, setPos] = useState(0);
  const [full, setFull] = useState(false);
  const language = Language();
  const isJapanese = countryUser === 'JP';

  const advanceImage = () => {
    if (pos !== images.length - 1) {
      setPos(pos + 1);
    } else {
      setPos(0);
    }
  };

  const backImage = () => {
    if (pos !== 0) {
      setPos(pos - 1);
    } else {
      setPos(images.length - 1);
    }
  };

  return (
    <div className='product'>
      {!full
        ? (
          <>
            <div className='product-container'>
              <div className='product-item'>
                <figure>
                  <ProductImage
                    advanceImage={advanceImage}
                    backImage={backImage}
                    currentImage={images[pos]}
                    imageStyle='product-hero__img'
                  />
                  <div className='product-img__full'>
                    <Icon
                      size='large'
                      name='expand'
                      onClick={() => setFull(true)}
                    />
                  </div>
                </figure>
              </div>
              <div className='product-item product-item__left'>
                <h1>360 WalkMix Creator™</h1>
                <p className='product-item__description'>{strings[language].description}</p>
                {(priceProduct && !isJapanese) && <h3>{priceProduct.gross}</h3>}
                <ProductHeroButton
                  isJapanese={isJapanese}
                  language={language}
                />
                {(priceProduct && !isCountriesTax(countryUser)) && <p className='product-tax'>{isJapanese ? strings[language].redirect : !entitlement && (strings[language].tax)}</p>}
              </div>
            </div>
            <Carrousel
              images={images}
              changeImage={setPos}
              pos={pos}
              setFull={setFull}
            />
          </>
        )
        : (
          <CarrouselFull
            advanceImage={advanceImage}
            backImage={backImage}
            currentImage={images[pos]}
            pos={pos}
            setFull={setFull}
          />
        )}
    </div>
  );
};

export default ProductHero;
